import AdminMemberDetailsPopUp from "./AdminMemberDetailsPopUp";

export default AdminMemberDetailsPopUp;
